import type { ReactNode } from 'react';

interface SectionCardProps {
  id?: string;
  title?: ReactNode;
  subtitle?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
}

export default function SectionCard({
  id,
  title,
  subtitle,
  action,
  children,
  className = '',
  bodyClassName = '',
}: SectionCardProps) {
  return (
    <section
      id={id}
      className={`section-lift rounded-lg border border-background-200 bg-background-50 ${className}`}
    >
      {(title || action) && (
        <header className="flex items-start justify-between gap-3 border-b border-background-200 px-5 py-4">
          <div>
            {title ? (
              <h3 className="font-heading text-sm font-semibold text-foreground-950">
                {title}
              </h3>
            ) : null}
            {subtitle ? (
              <p className="mt-0.5 text-xs text-foreground-500">{subtitle}</p>
            ) : null}
          </div>
          {action ? <div className="shrink-0">{action}</div> : null}
        </header>
      )}
      <div className={bodyClassName || 'p-5'}>{children}</div>
    </section>
  );
}